import { render, staticRenderFns } from "./DiscardModal.vue?vue&type=template&id=58ca843a&"
import script from "./DiscardModal.vue?vue&type=script&lang=js&"
export * from "./DiscardModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscardModal.vue?vue&type=style&index=0&id=58ca843a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports